// extracted by mini-css-extract-plugin
export default {"buttonAddBlock":"ButtonAddBlock_buttonAddBlock__yLlSl","buttonAddBlock__text":"ButtonAddBlock_buttonAddBlock__text__T3B4O"};